<template>
  <el-dialog title="上传管家业绩" :visible.sync="dialogVisible" width="560px" :close-on-click-modal="false" append-to-body
    @close="handleClose">
    <div class="import-dialog">
      <div class="upload-row">
        <span class="upload-label"></span>
        <div class="upload-content">
          <el-upload ref="upload" class="upload-box" action="#" drag :auto-upload="false" :show-file-list="false"
            :limit="1" accept=".xls,.xlsx" :http-request="handleUploadRequest" :before-upload="beforeUpload"
            :on-change="handleFileChange" :on-exceed="handleExceed">
            <i v-if="!fileName" class="el-icon-upload" style="padding-bottom: 25px;"></i>
            <svg v-if="fileName" t="1778664529021" class="icon" viewBox="0 0 1280 1024" version="1.1"
              xmlns="http://www.w3.org/2000/svg" p-id="6405" width="200" height="200">
              <path
                d="M714.5728 150.5792L320 229.1968v565.6064l394.5728 78.6304V150.5792z m-202.2144 384.768l-40.9856 88.9216-47.296-3.3024 59.8656-108.7232-53.5552-118.4768 47.2576-3.3024 31.5392 88.8704h6.2592l34.688-95.4752 50.432-3.264-63.04 125.0816 63.0784 128.4352-50.432-3.3024-37.8112-95.4624z"
                fill="#23B08D" p-id="6406"></path>
              <path d="M714.5728 243.6608H960V817.792H714.5728z" fill="#E5E7E6" p-id="6407"></path>
              <path
                d="M714.5728 371.2512h173.4784v53.7216H714.5728zM714.5728 484.4288h173.4784v53.7216H714.5728zM714.5728 612.5056h173.4784v53.7216H714.5728z"
                fill="#FFFFFF" p-id="6408"></path>
            </svg>
          </el-upload>
        </div>
      </div>
      <div class="file-name" v-if="fileName" style="display: flex; align-items: center;">
        <span>已选择：{{ fileName }}</span>
        <i class="el-icon-close" style="cursor: pointer; margin-left: 8px; color: #f56c6c; font-weight: bold;"
          @click="resetFile" title="删除文件"></i>
      </div>
      <div class="upload-tip">只能上传.xls、.xlsx文件，文件不能超过5MB</div>
      <el-button type="text" class="download-btn" :loading="downloadLoading" @click="handleDownloadTemplate">
        下载模板
      </el-button>
    </div>

    <span slot="footer" class="dialog-footer">
      <el-button type="primary" size="small" :loading="submitLoading" @click="handleSubmit">提交</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { employeeAssessmentTargetDownloadTemplate, employeeAssessmentTargetImportExcel } from '@/common/api';

export default {
  name: 'WithdrawalImportDialog',
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      submitLoading: false,
      downloadLoading: false,
    };
  },
  computed: {
    fileName() {
      return this.fileList.length ? this.fileList[0].name : '';
    },
  },
  watch: {
    visible: {
      immediate: true,
      handler(val) {
        this.dialogVisible = val;
      },
    },
    dialogVisible(val) {
      this.$emit('update:visible', val);
    },
  },
  methods: {
    beforeUpload(file) {
      const fileName = file.name || '';
      const fileNameArr = fileName.split('.');
      const fileType = (fileNameArr[fileNameArr.length - 1] || '').toLowerCase();
      const supportArr = ['xls', 'xlsx'];
      const isLt5M = file.size / 1024 / 1024 < 5;

      if (supportArr.indexOf(fileType) === -1) {
        this.$message.error('请上传xls或xlsx格式文件');
        return false;
      }

      if (!isLt5M) {
        this.$message.error('上传文件不能超过5MB');
        return false;
      }

      return true;
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList.slice(-1);
    },
    handleExceed() {
      this.$message.warning('只能上传一个文件');
    },
    async handleDownloadTemplate() {
      this.downloadLoading = true;
      try {
        const res = await employeeAssessmentTargetDownloadTemplate();
        const disposition = res.headers && res.headers['content-disposition'];
        const blob = new Blob([res.data], { type: 'application/vnd.ms-excel' });
        const downloadUrl = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = downloadUrl;
        a.download = this.getFilenameFromContentDisposition(disposition) || '管家业绩模板.xlsx';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        window.URL.revokeObjectURL(downloadUrl);
      } catch (error) {
        this.$message.error('模板下载失败');
      } finally {
        this.downloadLoading = false;
      }
    },
    handleSubmit() {
      if (!this.fileList.length) {
        this.$message.warning('请先选择上传文件');
        return;
      }
      this.$refs.upload.submit();
    },
    async handleUploadRequest(option) {
      this.submitLoading = true;
      try {
        const res = await employeeAssessmentTargetImportExcel({ file: option.file });
        const code = res && res.code;
        if (code === 0 || code === '200' || code === '20000') {
          this.$message.success(res.msg || res.message || '导入成功');
          option.onSuccess && option.onSuccess(res);
          this.$emit('success');
          this.dialogVisible = false;
          this.resetFile();
        } else {
          this.$message.error((res && (res.msg || res.message)) || '导入失败');
          option.onError && option.onError(res);
        }
      } catch (error) {
        this.$message.error('导入失败');
        option.onError && option.onError(error);
      } finally {
        this.submitLoading = false;
      }
    },
    handleClose() {
      this.resetFile();
    },
    resetFile() {
      this.fileList = [];
      if (this.$refs.upload) {
        this.$refs.upload.clearFiles();
      }
    },
    getFilenameFromContentDisposition(contentDisposition) {
      if (!contentDisposition) return '';
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(contentDisposition);
      if (matches && matches[1]) {
        return decodeURIComponent(matches[1].replace(/['"]/g, ''));
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
.import-dialog {
  min-height: 220px;
  display: flex;
  flex-direction: column;
  align-items: center;

  .upload-row {
    // display: flex;
    // align-items: flex-start;
  }

  .upload-label {
    width: 92px;
    line-height: 32px;
    font-size: 14px;
    color: #606266;
  }

  .upload-content {
    display: flex;
    align-items: center;
    gap: 12px;

    .upload-box {
      ::v-deep(.el-upload) {
        .el-upload-dragger {
          width: 150px !important;
          height: 150px !important;
          display: flex;
          align-items: center;
          justify-content: center;
        }

      }
    }
  }

  .download-btn {
    padding: 0;
    margin-top: 20px;
  }

  .file-name,
  .upload-tip {
    // margin-left: 92px;
    margin-top: 8px;
    font-size: 12px;
    color: #909399;
  }

  .file-name {
    color: #0055ff;
  }
}

.dialog-footer {
  display: block;
  text-align: center;
}
</style>
